import axios from 'axios';

export default {
  getAirCompanytList
};

const GET_AIRCOMPANY_V1 = 'catalog/api/v1/aircompany';

function getAirCompanytList() {
  return new Promise((resolve, reject) => {
    axios
      .get(GET_AIRCOMPANY_V1)
      .then(res => resolve(res))
      .catch(err => resolve([]));
  });
}



// WEBPACK FOOTER //
// ./src/services/airCompany/AirCompanyService.js